import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTareasStore } from "../store/api";
import { useAuth } from "./AuthContext";
import axios from "axios";
import { ApiErrorResponse } from "../DTO/ApiResponseError";
import LoadingModal from "../elementos/LoadingModal";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [errorUsername, setErrorUsername] = useState("");
  const [errorPassword, setErrorPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { loginApp } = useTareasStore();
  const { login } = useAuth();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    const loginData = {
      username,
      password,
    };

    if (!username.trim() || !password) {
      setErrorUsername(username.trim() ? "" : "El nombre de usuario es obligatorio");
      setErrorPassword(password ? "" : "La contraseña es obligatoria");
      return;
    }

    try {
      setLoading(true);
      //video seguridad java y react
      //  https://www.youtube.com/watch?v=W4hBA2gACik
      //video de como subir la app
      // https://www.youtube.com/watch?v=ojRc7DYxCoE
       await loginApp(loginData);
        const authHeader = `Basic ${btoa(`${username}:${password}`)}`;
        sessionStorage.setItem("authHeader", authHeader);
        login();
        navigate("/");
    
    } catch (error) {
      setError("");
      setErrorUsername("");
      setErrorPassword("");
      if (axios.isAxiosError<ApiErrorResponse>(error)) {

        const apiError = error.response?.data;
        const fieldErrors = apiError?.fieldErrors || {};

        if (fieldErrors && Object.keys(fieldErrors).length > 0) {
          setErrorUsername(fieldErrors.username ?? "");
          setErrorPassword(fieldErrors.password ?? "");
          return;
        }

        setError(apiError?.message ?? "Ha ocurrido un error inesperado.");
        return;

      }
      setError("Ha ocurrido un error inesperado.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="d-flex align-items-center justify-content-center vh-100 bg-light">
      <LoadingModal show={loading} message="Iniciando sesión..." />
      <form
        onSubmit={handleSubmit}
        className="card p-4 shadow-lg"
        style={{ width: "100%", maxWidth: "400px" }}
      >
        <h2 className="text-center mb-4">Bienvenido a la Gestión de Tareas</h2>

        <div className="mb-3">
          <label htmlFor="inputEmail" className="form-label">
            Correo electrónico
          </label>
          <input
            type="email"
            id="inputEmail"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            className="form-control"
            aria-describedby="emailHelp"
            placeholder="correo@ejemplo.com"
            required
          />
          <div id="emailHelp" className="form-text">
            Nunca compartiremos tu correo con nadie más.
          </div>
          {errorUsername && <div className="alert alert-danger py-2">{errorUsername}</div>}
        </div>

        <div className="mb-3">
          <label htmlFor="inputPassword" className="form-label">
            Contraseña
          </label>
          <input
            type="password"
            id="inputPassword"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="form-control"
            placeholder="••••••••"
            required
          />
          {errorPassword && <div className="alert alert-danger py-2">{errorPassword}</div>}
        </div>

        {error && <div className="alert alert-danger py-2">{error}</div>}

        <div className="d-grid">
          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? "Iniciando sesión..." : "Iniciar Sesión"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default Login;
